<app-navbar *ngIf="!hasOwnLayout"></app-navbar>

<main [class.content-container]="!hasOwnLayout">
  <router-outlet></router-outlet>
</main>
